import React from 'react'
import { bool, string } from 'prop-types'
import { Router } from '@reach/router'
import NoMatch from '../shared/NoMatch'
import CustomPartner from './CustomPartner'
import Organisations from './Organisations'
import Announcements from './Announcements'
import Partners from '../shared/PartnerList'
import ErrorBoundary from '../shared/ErrorBoundary'
import useOrganisations from '../shared/system/useOrganisations'
import { useTranslation } from 'react-i18next'
const SystemContent = ({
  '*': contextRoute,
  userId,
  isAdmin,
  selectedOrgId,
}) => {
  const { selected } = useOrganisations()
  const { t } = useTranslation()
  const organisationId = selected.id

  if (isAdmin) {
    return (
      <ErrorBoundary>
        <Router primary={false}>
          <Organisations
            organisationId={organisationId}
            t={t}
            path="organisations"
            userId={userId}
          />
          <Partners
            t={t}
            organisationId={organisationId}
            path="partners"
            scope="sys"
          />
          <CustomPartner t={t} path="add-outgoing-partner/*" />
          <Announcements path="announcements" />
          <NoMatch path="*" isRelative noThrow to="organisations" />
        </Router>
      </ErrorBoundary>
    )
  }
  if (!isAdmin) {
    // Non admins cannot access the System section, only redirect to home page
    return (
      <ErrorBoundary>
        <Router primary={false}>
          <NoMatch path="*" noThrow to={`/${selectedOrgId}/feeds`} />
        </Router>
      </ErrorBoundary>
    )
  }
}

SystemContent.propTypes = {
  '*': string,
  userId: string.isRequired,
  isAdmin: bool.isRequired,
  selectedOrgId: string.isRequired,
}

export default SystemContent
